import { flatten, getLocationsString, getLocationUnitOption } from './helpers'
import { Employee } from './interfaces'

export const toEmployee = (employee: Employee) => ({
  ...employee,
  userRoleList: employee.userRoleList
    ? employee.userRoleList.map(useRole => useRole.role.name)
    : [],
  contractList: employee.contractList
    ? employee.contractList.map(contract => ({
        ...contract,
        employeeType: contract.employeeType ?? '',
        jobTitle: contract.jobTitle ?? '',
        locations: contract.contractLocationList
          ? getLocationsString(contract.contractLocationList)
          : ''
      }))
    : []
})

export const toLocationUnitsOptions = locationUnit => {
  let result = [getLocationUnitOption(locationUnit)]
  const children = locationUnit.childList ? flatten({ childList: locationUnit.childList }) : []

  return [
    ...result,
    ...children?.map(getLocationUnitOption).sort((a, b) => a.groupBy.localeCompare(b.groupBy))
  ]
}
